module.exports = __webpack_public_path__ + "img/partner-new6.e99b5be6.png";